import React, { useContext, useEffect, useState } from "react";
import "../../../assests/css/students/Blogs.css";
import TopBlogCard from "../../../components/students/TopBlogCard/TopBlogCard";
import BlogCard from "../../../components/students/BlogCard/BlogCard";
import TopHero from "../../../subscreens/TopHero/TopHero";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";

const Blogs = () => {

  const {baseUrl} = useContext(AppContext);
  const [blogs, setBlogs] = useState([]);

  const fetchAllBlogs = () => {
    axios.get(`${baseUrl}/student/blogs/fetchAllBlogs`)
    .then((res) => {
      console.log(res.data)
      if(res.data.success == true){
        setBlogs(res.data.blogs)
      }
     })
    .catch((err) => {
      console.log(err)
     })
  }
  useEffect(() => {
    fetchAllBlogs();
  }, [])

  return (
    <div className="blogs-page">

      {/* ================= HERO SECTION ================= */}
      <TopHero
        title="Our Blogs"
        description="Explore insights, articles, and updates from our academic and professional community."
      />
      {/* <section className="blogs-hero">
        <div className="blogs-hero-bg"></div>
        <div className="blogs-hero-overlay"></div>

        <div className="blogs-hero-content">
          <h2>Our Blogs</h2>
          <p>
            Explore the latest articles, study tips, campus updates, and
            educational insights from our college.
          </p>
        </div>
      </section> */}

      {/* ================= BLOG CONTENT ================= */}
      <div className="cb-wrapper">

        {/* Categories */}
        <div className="cb-categories">
          {/* <button className="cb-cat active">All Articles</button> */}
          {/* <button className="cb-cat">Campus Life</button>
          <button className="cb-cat">Study Tips</button>
          <button className="cb-cat">Education News</button> */}
        </div>

        {/* Top Section */}
        <div className="cb-top-section">
          {/* <TopBlogCard blog = {blogs}/> */}

          {/* <div className="cb-side-blogs">
            <h4 className="cb-side-heading">Study Tips</h4>
            <BlogCard />
            <BlogCard />
          </div> */}
        </div>

        {/* Latest Articles */}
        <h3 className="cb-section-title">Latest Articles</h3>
        <div className="cb-grid">
          {blogs.map((blog)=>{
            return <BlogCard blog = {blog} />
          })}
          {/* <BlogCard />
          <BlogCard />
          <BlogCard /> */}
        </div>

        {/* Previous Articles */}
        <h3 className="cb-section-title">Previous Articles</h3>
        <div className="cb-grid">
          {blogs.map((blog)=>{
            return <BlogCard blog = {blog} />
          })}
        </div>

      </div>
    </div>
  );
};

export default Blogs;
